// extracted by mini-css-extract-plugin
module.exports = {"textarea":"textareaElement_textarea__2H5ap"};